import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderCardModal = (data) => openPopupHelper({ popupName: popupNames.UPDATE_CARD, data });

export const closeCardModal = () => closePopupHelper(popupNames.UPDATE_CARD);
